// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFunnelPlotOutlinedSvg from "@fishx/icons-svg/es/asn/PFunnelPlotOutlined";
import FishxIcon from '../components/FishxIcon';

var PFunnelPlotOutlined = function PFunnelPlotOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFunnelPlotOutlinedSvg
  }));
};

PFunnelPlotOutlined.displayName = 'PFunnelPlotOutlined';
export default React.forwardRef(PFunnelPlotOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFunnelPlotOutlined.js
// module id = 3435
// module chunks = 0